 
import Game from './game'

export default class OrderableGame extends Game {
  get asJson () {
    const json = super.asJson
    json.playersCount = this._parent?.orderableStore?.playersCount
    json.roomId = json.room?.id || json.roomId
    delete json.room
    json.reservedTo = json.reservedTo !== undefined ? json.reservedTo.toString() : json.reservedTo
    return json
  }
}

OrderableGame.paramName = 'game'
